var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"sm":12,"lg":6}},[_c('el-result',{attrs:{"icon":"warning","title":"警告提示","subTitle":"请根据提示进行操作"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.BackToActivityBoard}},[_vm._v("返回")])],1)],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }